<template>
  <component :is="component" :paginationData="paginationData" :itemData="itemData" v-if="component"/>
</template>

<script>
export default {
  name: "ItemListLink",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
    listLayout: {},
    itemData: {
      type: Array,
      default: () => {
        return []
      }
    },
      paginationData: {
          type: Object,
          default: ()=> {
              return {
                  total: 0,
                  page: 0,
                  size: 0,
              }
          }
      },
  },
  data() {
    return{
      component: null,
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {
    this.listLoader();
  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
    loader() {
      if (!this.listLayout) {
        return null
      }
      return () => import(`@/template/item/list/${this.listLayout}`)
    },
  },
  methods:{
    listLoader() {
      this.loader()
          .then(() => {
            this.component = () => this.loader()
          })
          .catch(() => {
            this.component = () => import('@/template/item/list/ItemListDefaultLayout')
          })
    }
  },
  watch: {

  },
}
</script>

<style scoped>

</style>
